export { default } from './es/icons/AddFilled';